import { Box, LinearProgress, useTheme } from '@mui/material';

export interface HorizontalProgressBarProps {
    steps: string[];
    activeTaskName?: string;
    startEmpty?: boolean;
}

export default function HorizontalProgressBar({
    steps,
    activeTaskName,
    startEmpty = false,
}: HorizontalProgressBarProps) {
    const theme = useTheme();

    let progress: number;
    const hasActiveTask = activeTaskName && steps.includes(activeTaskName);
    if (hasActiveTask) {
        const idx = steps.indexOf(activeTaskName);
        progress = ((idx + 1) / steps.length) * 100;
    } else if (!startEmpty) {
        progress = 100;
    } else {
        progress = 0;
    }

    return (
        <Box sx={{ width: '100%', px: { xs: 0, md: 3 }, pb: 2 }}>
            <LinearProgress
                variant="determinate"
                value={progress}
                color="primary"
                sx={{
                    height: 2,
                    backgroundColor: theme.palette.grey[100],
                }}
                data-testid="progress-bar"
            />
        </Box>
    );
}
